import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { FoljaForma, FoljaKoha, FoljaVeta, FoljaNumri, FoljaMenyra } from '@core/enums/folja.enum';
import { FoljaUrdherore } from '@core/globals/folja/folja-urdherore-constants';
import { FoljaConstants } from '@core/globals/folja/folja.constants';
import { FoljaUrdheroreForCreationDTO } from '@core/interfaces/dto/folja-urdherore-for-creation-dto.interface';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';
import { FoljaUrdheroreFormulaService } from './folja-urdherore-formula.service';

@Injectable({
  providedIn: 'root',
})
export class FoljaUrdheroreService {
  constructor(private foljaUrdheroreFormulaService: FoljaUrdheroreFormulaService, private fb: UntypedFormBuilder) { }

  insertForms(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    let formArrays = ['foljaBaza.foljaUrdheroreInitial', 'foljaBaza.foljaUrdherore'];
    for (let i = 0; i < formArrays.length; i++) {

      const formArray = form.get(formArrays[i]) as UntypedFormArray;
      this.generateUrdheroreForms(formArray);
      foljaBaza.foljaUrdherore?.forEach((item) => {
        let index = formArray.controls.findIndex(
          (c) =>
            c.get('kohaId')?.value == item.kohaId &&
            c.get('formaId')?.value == item.formaId &&
            c.get('vetaId')?.value == item.vetaId &&
            c.get('numriId')?.value == item.numriId &&
            c.get('pershkrimi')?.value == '' &&
            c.get('renditja')?.value == item.renditja
        );
        if (index != -1) {
          formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
        } else {
          this.addNewLakimi(formArray, item.kohaId, item.formaId, item.vetaId, item.numriId, item.pershkrimi, item.renditja);
        }
      });
    }
  }

  generateForms(formArray: UntypedFormArray) {
    this.generateUrdheroreForms(formArray);
  }

  generateFormula(baza: string, foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.foljaUrdheroreFormulaService.generateFormula(baza, foljaBaza, form.get('foljaBaza.foljaUrdherore') as UntypedFormArray);
  }

  private generateUrdheroreForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const fk of FoljaUrdherore.FoljaUrdheroreKoha) {
      for (const ff of FoljaConstants.FoljaForma) {
        for (const fn of FoljaConstants.FoljaNumri) {
          const foljaForm = this.fb.group({
            kohaId: fk.id,
            formaId: ff.id,
            vetaId: FoljaVeta.Edyte,
            numriId: fn.id,
            pershkrimi: '',
            renditja: 1
          });

          formArray.push(foljaForm);
        }
      }
    }
  }

  addNewLakimi(formArray: UntypedFormArray, koha: FoljaKoha, forma: FoljaForma, veta: FoljaVeta, numri: FoljaNumri, pershkrimi?: string, renditja?: number) {
    const renditjet = formArray.value.filter((c: any) => c.kohaId == koha && c.formaId == forma && c.vetaId == veta && c.numriId == numri).map((c: any) => c.renditja);
    const prevIndex = Math.max(...(renditjet.length > 0 ? renditjet : [0]));
    const foljaForm = this.fb.group({
      kohaId: koha,
      formaId: forma,
      vetaId: veta,
      numriId: numri,
      pershkrimi: pershkrimi,
      renditja: renditja ?? prevIndex + 1
    });
    formArray.push(foljaForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: FoljaUrdheroreForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('foljaBaza.foljaUrdherore') as UntypedFormArray;

    const veproreParam = form.get('foljaBaza.veproreParam')?.value;
    const joveproreParam = form.get('foljaBaza.joveproreParam')?.value;
    const veproreNjejesParam = form.get('foljaBaza.veproreNjejesParam')?.value;
    const veproreShumesParam = form.get('foljaBaza.veproreShumesParam')?.value;
    const joveproreNjejesParam = form.get('foljaBaza.joveproreNjejesParam')?.value;
    const joveproreShumesParam = form.get('foljaBaza.joveproreShumesParam')?.value;

    let formArrayValue = formArray.getRawValue();

    if (!veproreParam) {
      formArrayValue = formArrayValue.filter((f: any) => f.formaId != FoljaForma.Veprore);
    } else {
      if (veproreNjejesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.Veprore ||
            (f.numriId == FoljaNumri.Njejes && f.vetaId == FoljaVeta.Edyte) ||
            (veproreShumesParam && f.numriId == FoljaNumri.Shumes)
        );
      }
      if (veproreShumesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.Veprore ||
            (f.numriId == FoljaNumri.Shumes && f.vetaId == FoljaVeta.Edyte) ||
            (veproreNjejesParam && f.numriId == FoljaNumri.Njejes)
        );
      }
    }
    if (!joveproreParam) {
      formArrayValue = formArrayValue.filter((f: any) => f.formaId != FoljaForma.JoVeprore);
    } else {
      if (joveproreNjejesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.JoVeprore ||
            (f.numriId == FoljaNumri.Njejes && f.vetaId == FoljaVeta.Edyte) ||
            (joveproreShumesParam && f.numriId == FoljaNumri.Shumes)
        );
      }
      if (joveproreShumesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.JoVeprore ||
            (f.numriId == FoljaNumri.Shumes && f.vetaId == FoljaVeta.Edyte) ||
            (joveproreNjejesParam && f.numriId == FoljaNumri.Njejes)
        );
      }
    }

    formArrayValue.forEach((e: any) => {
      creationDTO.push({
        kohaId: e.kohaId,
        formaId: e.formaId,
        vetaId: e.vetaId,
        numriId: e.numriId,
        pershkrimi: e.pershkrimi,
        renditja: e.renditja
      });
    });

    return creationDTO;
  }

  getErrors(foljaForm: UntypedFormGroup) {
    let errors: {
      menyraId: number;
      kohaId: number;
      formaId: number;
      vetaId: number;
      numriId: number;
      formaFjalesId?: number | null;
      pershkrimi: string;
    }[] = [];
    let initial = foljaForm.getRawValue().foljaUrdheroreInitial;
    let formula = foljaForm.getRawValue().foljaUrdherore;

    for (const fk of FoljaUrdherore.FoljaUrdheroreKoha) {
      for (const ff of FoljaConstants.FoljaForma) {
        for (const fn of FoljaConstants.FoljaNumri) {
          const fmap = formula
            .filter((a: any) => a.kohaId == fk.id && a.formaId == ff.id && a.vetaId == FoljaVeta.Edyte && a.numriId == fn.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          const imap = initial
            .filter((a: any) => a.kohaId == fk.id && a.formaId == ff.id && a.vetaId == FoljaVeta.Edyte && a.numriId == fn.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          if (fmap != imap) {
            errors.push({
              menyraId: FoljaMenyra.Urdherore,
              kohaId: fk.id,
              formaId: ff.id,
              vetaId: FoljaVeta.Edyte,
              numriId: fn.id,
              pershkrimi: imap
            });
          }
        }
      }
    }

    return errors;
  }
}
